import { Facts } from "~/components/ui/Facts";
import { InfoBox } from "~/components/ui/InfoBox";
import { useT } from "~/util/Lang";
import { formatDate } from "../Date";

type Params = {
  user: {
    createdAt: string | Date;
  };
  counters: {
    comments: number;
  };
};

export function UserSidebar(params: Params) {
  const t = useT();
  const { user, counters } = params;
  return (
    <>
      <InfoBox
        title={t({
          en: "Information",
          ru: "Краткая информация",
        })}
      >
        <Facts
          facts={[
            {
              name: t({ en: "Joined", ru: "Регистрация" }),
              value: formatDate(user.createdAt),
            },
            {
              name: t({ en: "Rating", ru: "Рейтинг" }),
              value: 0,
            },
          ]}
        />
      </InfoBox>
      <InfoBox
        title={t({
          en: "Contributions",
          ru: "Cодействие",
        })}
      >
        <Facts
          facts={[
            {
              name: t({ en: "Comments", ru: "Комментарии" }),
              value: counters.comments,
            },
            {
              name: t({ en: "Pages", ru: "Страницы" }),
              value: 0,
            },
          ]}
        />
      </InfoBox>
    </>
  );
}
